import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
// import CustomizedDataGrid from './CustomizedDataGrid';
import PageViewsBarChart from './PageViewsBarChart';
import SessionsChart from './SessionsChart';
import StatCard from './StatCard';
import PropertiesTable from './PropertiesTable';
import { useNavigate } from 'react-router-dom';

const data = [
  {
    title: 'Property Holdings Value',
    value: '$3.4M',
    interval: 'Last 90 days',
    trend: 'up',
    data: [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 17, 18, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20
    ],
  },
  {
    title: 'Investments in Property Improvements',
    value: '$121K',
    interval: 'Last 90 days',
    trend: 'up',
    data: [
      0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 14, 15
    ],
  },
  {
    title: 'Sales Returns',
    value: '$53K',
    interval: 'Last 90 days',
    trend: 'up',
    data: [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 5, 5, 5, 5, 5
    ],
  },
];

export default function MainGrid({ setSelectedMenu }) {

  const handleClick = () => {
    setSelectedMenu('Buy Listing');
  };
  
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%' } }}>
      <Typography variant="body1" sx={{ color: 'text.secondary', fontWeight: 600 }}>
        Home
      </Typography>
      {/* cards */}
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Property Details
      </Typography>
      <Grid item xs={12} md={6} sx={{ pb: 4 }}>
          <PropertiesTable />
          <Button variant="outlined" color="primary" onClick={handleClick}>
            Show Selected
          </Button>
      </Grid>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Property Overview
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {data.map((card, index) => (
          <Grid key={index} item xs={12} sm={6} lg={3}>
            <StatCard {...card} />
          </Grid>
        ))}

        <Grid item xs={12} md={6}>
          <SessionsChart />
        </Grid>
        <Grid item xs={12} md={6}>
          <PageViewsBarChart />
        </Grid>
      </Grid>
        <Typography
          variant="body2"
          align="center"
          sx={{ color: 'text.secondary', p: 2 }}
        >
          &copy; 2024/2025 Rocket Offer. All rights reserved.
        </Typography>
    </Box>
  ); 
}
